var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg39(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.64,5.27c-10.35,0-18.75,8.39-18.75,18.75s8.39,18.75,18.75,18.75c10.35,0,18.75-8.39,18.75-18.75 S29.99,5.27,19.64,5.27z M19.64,9.23c6.85,0,12.62,4.66,14.3,10.99l-2.77-0.29c-7.66-0.81-15.39-0.81-23.05,0l-2.77,0.29 C7.02,13.89,12.78,9.23,19.64,9.23z M23.17,25.84c0,1.95-1.58,3.53-3.53,3.53s-3.53-1.58-3.53-3.53s1.58-3.53,3.53-3.53 S23.17,23.89,23.17,25.84z M4.97,25.91l3.38-0.02c2.94-0.02,4.5,3.47,2.53,5.65l-2.19,2.42C6.7,31.78,5.36,28.99,4.97,25.91z  M12.28,36.85l4.17-3.44c1.85-1.53,4.53-1.53,6.38,0L27,36.85c-2.17,1.25-4.68,1.96-7.36,1.96C16.96,38.81,14.44,38.1,12.28,36.85z  M30.59,33.96l-2.19-2.42c-1.97-2.18-0.41-5.67,2.53-5.65l3.38,0.02C33.91,28.99,32.58,31.78,30.59,33.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44.63,37.94h-0.81c-0.93,0-1.69-0.74-1.72-1.67L41.24,7.7c-0.03-0.97,0.75-1.77,1.72-1.77h2.55 c0.97,0,1.75,0.8,1.72,1.77l-0.87,28.58C46.32,37.2,45.56,37.94,44.63,37.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.46,41.19c0,1.23-1,2.23-2.23,2.23s-2.23-1-2.23-2.23c0-1.23,1-2.23,2.23-2.23S46.46,39.95,46.46,41.19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg39);
export default __webpack_public_path__ + "static/media/39.b55130707f71c1fcc334da93ef232425.svg";
export { ForwardRef as ReactComponent };